import Profile from "../../components/Profile/Profile";

export default function ProfilePage() {
    return (
        <Profile />
    )
};